(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NavbarV2Controller', NavbarV2Controller);

    NavbarV2Controller.$inject = ['__config', '$location', '$window', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'UserCustom', '$scope', 'CompanyInfoQuery', 'CompanyCustom', '$rootScope', '$translate', '$localStorage', '$uibModal', 'CompanySubscriptionStatusCustom', 'DialogService', 'ENV', '$timeout', 'DriverJsFunction', 'DeviceService'];

    function NavbarV2Controller(__config, $location, $window, $state, Auth, Principal, ProfileService, LoginService, UserCustom, $scope, CompanyInfoQuery, CompanyCustom, $rootScope, $translate, $localStorage, $uibModal, CompanySubscriptionStatusCustom, DialogService, ENV, $timeout, DriverJsFunction, DeviceService) {
        var vm = this;

        vm.appVersion = 'v2';
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.inProduction = true;
        vm.swaggerDisabled = true;
        vm.showGtag = ENV.ENVIRONMENT === 'production'
        //ProfileService.getProfileInfo().then(function(response) {
        //    vm.inProduction = response.inProduction;
        //    vm.swaggerDisabled = response.swaggerDisabled;
        //});
        vm.__config = __config;
        vm.login = login;
        vm.changeCCkey = changeCCkey;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.setCurrentPersonInfo = setCurrentPersonInfo;
        vm.userProfile = null;
        vm.company = null;
        vm.gotoWebSite = gotoWebSite;
        vm.gotoReserwebHelp = gotoReserwebHelp;
        vm.openInbox = openInbox;
        vm.isInboxOpened = false;
        vm.findAppVersion = findAppVersion;
        vm.selectedCompany = null;
        vm.setChatUserInfo = setChatUserInfo;
        vm.openChat = openChat;
        vm.supportButtonClick = supportButtonClick;
        vm.openMyWebsiteBox = openMyWebsiteBox;
        vm.showHeaderNavbar = true;
        vm.subscriptionStatusTitle = "اشتراک فعال";
        vm.goToHelp = goToHelp;
        vm.goToEducationLinks = goToEducationLinks
        vm.canDowngradeVersion = canDowngradeVersion;
        vm.downgradeVersion = downgradeVersion;
        vm.upgradeVersion = upgradeVersion;
        vm.subscriptionTitleStyle = subscriptionTitleStyle;
        vm.showWizard = showWizard;
        vm.isNativeApp = null;
        vm.referralCode = ''

        // vm.companies = [{"id":64543,"title":"شم3به شماره ۹","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان ش3به شماره ۹","phoneNumber":"04143334091","activityType":"BUSINESS_CONSULTING","webSiteUrl":null,"keyUrl":"tamin20","settingId":267841,"agreementId":64544,"locationId":71404,"locationInfo":{"id":71404,"title":null,"address":"تهران - میدان انقلاب","mapX":"35.70080152485188","mapY":"51.389923095703125","isActive":null,"countryId":1011,"stateId":1010,"cityId":36174},"tags":[],"agreementInfo":{"id":64544,"rules":null,"agreement":null},"setting":{"id":267841,"settingName":null,"themeSettingInfoId":267842,"notificationSettingId":267839,"financialSettingId":267840,"themeSettingInfo":{"id":267842,"name":null,"logoImageId":null,"albumInfoId":null},"notificationSetting":{"id":267839,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"SMS_AND_EMAIL","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"NONE"},"financialSetting":{"id":267840,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"servant_label\":\"مشاور\",\"servants_label\":\"مشاوران\",\"servant_list_access_mode\":\"MENU\",\"durationViewMode\":\"HIDE\",\"isClientEmailRequired\":\"TRUE\",\"capacityViewMode\":\"SHOW\"}","domain":null,"hasDedicatedDomain":null,"appVersion":"v2","parentId":null,"companyMode":"PARENT_COMPANY","category":null,"orderNo":null},
        //     {"id":61892,"title":"sh12","shortTitle":null,"description":"سامانه نوبت دهی خدمات کارگزاری های سازمان sh12","phoneNumber":"-","activityType":"OTHER","webSiteUrl":null,"keyUrl":"tamin12","settingId":61902,"agreementId":61893,"locationId":null,"locationInfo":{"id":null,"title":null,"address":null,"mapX":null,"mapY":null,"isActive":null,"countryId":null,"stateId":null,"cityId":null},"tags":[],"agreementInfo":{"id":61893,"rules":null,"agreement":null},"setting":{"id":61902,"settingName":null,"themeSettingInfoId":61903,"notificationSettingId":61900,"financialSettingId":61901,"themeSettingInfo":{"id":61903,"name":null,"logoImageId":64894,"albumInfoId":64896},"notificationSetting":{"id":61900,"sendBookingConfirmation":"SMS_AND_EMAIL","sendOnCancelBooking":null,"sendOnMoveBooking":null,"sendCustomerReminder":"SMS_AND_EMAIL","reminderTimeInAdvanced":24.0,"sendBookingConfirmationSupplier":"NONE","sendUserRegistrationMessage":"SMS_AND_EMAIL","sendCustomerSatisfactionMessage":"SMS_AND_EMAIL"},"financialSetting":{"id":61901,"taxPercentage":0.0,"hasDiscount":null,"currency":"RIAL","inPlacePayment":true}},"status":"ACTIVE","workingTimes":[],"telegramBotName":null,"telegramBotToken":null,"subscriptionType":null,"customSetting":"{\"parentId\":\"3258294\"}","domain":null,"hasDedicatedDomain":null,"appVersion":null,"parentId":64543,"companyMode":null,"category":"AGENT","orderNo":null}]

        $rootScope.$on('openNavBarHelpEvent', function (event) {
            vm.openMenu();
        })


        $scope.$on('hideNavBar', function () {

            showNavBar(false);
        });

        $scope.$on('showNavBar', function () {
            showNavBar(true);
        });

        $scope.$on('reloadNavBarData', function () {
            setCurrentPersonInfo();
            setCurrentCompany();
        });

        function showNavBar(value) {
            vm.showHeaderNavbar = value;

            if (!$state.current.parent.includes('supplierPanel-v2'))
                return;

            var elem = document.getElementById('main-content');

            if (!vm.showHeaderNavbar) {
                elem.classList.add('hide-nav-bar');
                // elem.style.paddingTop = '0';
                // elem.style.paddingBottom = '0';
            } else {
                elem.classList.remove('hide-nav-bar');
                // elem.style.paddingTop = '60px';
                // elem.style.paddingBottom = '60px';
            }
        }

        document.addEventListener('goftino_ready', function (evt) {
            vm.chatIsReady = true;
        });

        var cckey = $location.search().cckey;

        function changeCCkey(companyUrl) {
            cckey = companyUrl;
            changeCurrentCompany();

        }

        function changeCurrentCompany() {
            if (cckey) {
                CompanyCustom.changeCurrentCompany(cckey).query(function (c) {
                    $window.location.reload();
                    // setCurrentCompany();

                });
            }

        }

        // function changeCurrentCompany(key)
        // {
        //     if(key)
        //         cckey = key;
        //     changeCurrentCompany();
        // }


        setDefaultsForWeDoMeet();
        setCurrentPersonInfo();
        setCurrentCompany();

        function login() {
            collapseNavbar();
            LoginService.open();

        }

        function logout() {
            collapseNavbar();
            Auth.logout();

            $('.navbar-fixed-top').removeClass('compact');
            $('#sidebar').removeClass('open');
            $('#menuHamburgerDesktop').removeClass('change');
            $('.navbar-fixed-top').removeClass('compact');
            $('#page-wrapper').removeClass('compact');
            vm.company = null;
            vm.companies = null;
            vm.userProfile = null;

            $state.go('home');

        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function setCurrentPersonInfo() {
            if (Principal.isAuthenticated()) {
                UserCustom.getCurrentUserProfile().query(function (up) {
                    vm.userProfile = up
                });

                vm.companies = UserCustom.getCurrentUserCompanies().query();
            }
        }

        function setCurrentCompany() {
            if (Principal.isAuthenticated()) {

                CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                    vm.company = c;
                    if (c && c.appVersion && c.appVersion == 'v3') {
                        vm.appVersion = 'v3'
                    }
                    vm.selectedCompany = vm.company;
                    Principal.setCurrentCompany(vm.company);
                    Principal.getCurrentCompanyFeatureList();
                    CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
                        vm.companySubscriptionStatusList = entity;
                        if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                            vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];
                            vm.currentSubscriptionStatus = 'ACTIVE';
                            vm.subscriptionStatusTitle = 'اشتراک فعال';
                            if (vm.activePackage.subscriptionPackage.subscriptionType == 'FREE')
                                vm.subscriptionStatusTitle = 'اشتراک رایگان';
                        } else {
                            vm.currentSubscriptionStatus = 'EXPIRED';
                            vm.subscriptionStatusTitle = 'اشتراک ندارید';
                        }

                    });

                });


            }
        }

        function openInbox() {
            vm.isInboxOpened = true;
        }

        function gotoWebSite() {
            if (vm.company != null && vm.company.keyUrl != null && vm.company.keyUrl != undefined) {
                window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
            } else {
                if (Principal.isAuthenticated()) {

                    CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {

                        vm.company = c;
                        vm.selectedCompany = vm.company;

                        window.open('http://' + vm.company.keyUrl + '.' + vm.__config.domain, '_blank');
                    });


                }
            }
        }

        function gotoReserwebHelp() {

            var helpUrl = getHelpUrl();
            window.open(helpUrl, '_blank');
        }

        function getHelpUrl() {
            if (vm.__config.appMode == 'reserve') {
                return "https://planovin.com/help";
            }
            if (vm.__config.appMode == 'event')
                return "https://wedomeet.ir/help";
        }

        function findAppVersion() {

            collapseNavbar();
            if (vm.company != null && vm.company.appVersion == 'v2') {
                $state.go('supplierPanel.calendar', { stateParamKey: null });
            } else {
                $state.go('supplierPanel.timeBoard', { stateParamKey: null });
            }


        }

        function setDefaultsForWeDoMeet() {
            $translate.use('en');
            $localStorage.appMode = 'reserve';

            if (vm.__config.appMode == 'event') {
                $translate.use('zu');
                $localStorage.appMode = 'event';
            }
            // else{
            //     if(vm.__config.appName && vm.__config.appName =="planovin")
            //     {
            //         $translate.use('pl');
            //         $localStorage.appMode = 'reserve';
            //     }
            // }


        }

        function supportButtonClick() {
            Goftino.toggle();
            setChatUserInfo();
        }

        function setChatUserInfo() {

            if (!vm.chatIsReady)
                return;
            if (!vm.userProfile)
                return;
            if (!vm.userProfile.personInfo)
                return;

            var email = 'no@Email';
            if (vm.userProfile.personInfo.email)
                email = vm.userProfile.personInfo.email;
            var fullName = vm.userProfile.personInfo.fisrtName + ' ' + vm.userProfile.personInfo.lastName;
            var company = vm.selectedCompany.title + ' - ' + vm.selectedCompany.keyUrl;
            var phoneNumber = '111111';
            if (vm.userProfile.personInfo.phoneNumber)
                phoneNumber = vm.userProfile.personInfo.phoneNumber;


            Goftino.setUser({
                email: email,
                name: fullName,
                about: company,
                phone: phoneNumber,
                forceUpdate: true
            });


        }

        vm.openMenu = function ($mdMenu, ev) {
            vm.originatorEv = ev;
            $mdMenu.open(ev);
        };

        function openChat() {
            Goftino.toggle();
            setChatUserInfo();
        }

        vm.callSupport = function () {
            window.open('tel:02191690817');
        }

        function openMyWebsiteBox() {
            $uibModal.open({
                templateUrl: 'app/layouts/navbar/my-website.html',
                controller: 'MyWebsiteController',
                controllerAs: 'vm',
                // backdrop: 'static',
                size: 'sm',
                windowClass: 'pl-modal-sm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            company: vm.company
                        };
                    }
                }
            })

        }

        vm.toggleSideMenu = function () {
            var elem = document.getElementById('navbar-desktop');
            if (elem) {
                if (elem.classList.contains('navbar-desktop-side-open')) {
                    elem.classList.remove('navbar-desktop-side-open');
                    $localStorage.sideMenuStatus = 'close';
                } else {
                    elem.classList.add('navbar-desktop-side-open');
                    $localStorage.sideMenuStatus = 'open';
                }

            }

            $rootScope.$broadcast('toggleSideMenu');
        }

        $scope.$on('resetToggleSideMenu', function () {
            var elem = document.getElementById('navbar-desktop');
            if (elem) {
                if (elem.classList.contains('navbar-desktop-side-open'))
                    elem.classList.remove('navbar-desktop-side-open');
            }
        });


        $scope.$watch(function () {
            return cckey;
        }, function () {
            changeCurrentCompany();
        });
        $scope.$watch(function () {
            return Principal.isAuthenticated();
        }, function () {
            setCurrentPersonInfo();
            setCurrentCompany();


        });


        vm.navBarShowV3 = function () {
            var isInitSetUp = false;

            if ($state.current.name == 'initSetupWizardV2') {
                isInitSetUp = true;
            }

            if ($state.current.name == 'createUserAccount')
                return true;

            if (vm.appVersion == 'v3' || isInitSetUp) {
                return true;
            } else {
                return false;
            }
        }


        function goToHelp() {
            var helpUrl = 'https://www.planovin.com/help'
            window.open(helpUrl, '_blank');
        }
         function goToEducationLinks() {
            var helpUrl = 'https://www.aparat.com/playlist/12329237'
            window.open(helpUrl, '_blank');
        }
        function canDowngradeVersion() {
            if (vm.company && vm.company.appVersion
                && vm.company.appVersion == 'v3'
                && !vm.company.wizardStatus
            ) {
                return true;
            }

            return false;
        }

        function downgradeVersion() {
            DialogService.showConfirmV2("بازگشت به نسخه قدیم را تایید می فرمایید ؟").then(function () {
                CompanyCustom.downgradeVersion().save(null, onDowngradeSuccess, onDowngradeError);
            });

        }

        function onDowngradeSuccess() {
            vm.appVersion = 'v2';
            $state.go('supplierPanel.dashboard');
        }

        function onDowngradeError() {

        }

        function upgradeVersion() {
            DialogService.showConfirmV2("بروز رسانی به نسخه جدید را تایید می فرمایید ؟").then(function () {
                CompanyCustom.upgradeVersion().save(null, onUpgradeSuccess, onUpgradeError);
            });
        }

        function onUpgradeSuccess() {
            vm.appVersion = 'v3';
            $state.go('supplierPanel-v2.dashboard');
        }

        function onUpgradeError() {

        }

        function subscriptionTitleStyle() {
            if (vm.currentSubscriptionStatus == 'EXPIRED')
                return 'subscriptionExpired';
        }
        function showWizard() {
            DriverJsFunction.drive();
        }
        $timeout(function(){
            vm.isNativeApp = $localStorage.isNativeApp;
        },10)
        function findTypeOfUserDevice() {
            if($localStorage.isNativeApp == "true"){         
                vm.referralCode = "android"
            }
        }
        findTypeOfUserDevice()
        //$scope.$watch(function() {
        //    return Principal.getCurrentCompany();
        //}, function() {
        //    setCurrentCompany();
        //});
    }
})();
